module.exports = __webpack_public_path__ + "static/media/workspace.4b104363.png";